import React from 'react'
import { Button, Callout } from '@superhi/design'

import { buildPath } from 'src/routing'

const AboutCallout: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Callout
    title="Want to know more? Meet the team &amp; learn about why we do what we do."
    backgroundColor="green"
  >
    <Button level={Callout.ButtonLevel} href={buildPath('about')}>
      View our About page
    </Button>
  </Callout>
)

export default AboutCallout
